import { render } from "./ChangePasswordWidget.vue?vue&type=template&id=2550d8fc&scoped=true&lang=pug"
import script from "./ChangePasswordWidget.vue?vue&type=script&lang=js"
export * from "./ChangePasswordWidget.vue?vue&type=script&lang=js"

import "./ChangePasswordWidget.vue?vue&type=style&index=0&id=2550d8fc&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2550d8fc"]])

export default __exports__